import { useTranslation } from "react-i18next"

import { CloudUpload, FileUp } from "@/components/icons"
import { cn } from "@/lib/utils"

type UploadDragOverlayProps = {
  isDragOver: boolean
  isUploading: boolean
  className?: string
}

export function UploadDragOverlay({ isDragOver, isUploading, className }: UploadDragOverlayProps) {
  const { t } = useTranslation()
  if (!isDragOver && !isUploading) return null

  return (
    <div
      className={cn(
        "border-secondary bg-secondary/25 absolute inset-0 z-50 flex flex-col items-center justify-center border-2 border-dashed backdrop-blur-sm",
        className
      )}
    >
      <div className="border-border bg-background/95 dark:border-border/50 flex flex-col items-center justify-center space-y-6 rounded-lg border p-12 shadow-2xl backdrop-blur-sm">
        {isUploading ? (
          <>
            <div className="relative">
              <div className="bg-primary/10 flex h-20 w-20 items-center justify-center rounded-full">
                <FileUp className="text-primary h-10 w-10 animate-bounce [animation-duration:1s]" />
              </div>
            </div>
            <div className="text-center">
              <p className="animate-shimmer from-foreground via-foreground/50 to-foreground mb-2 bg-gradient-to-r bg-[length:200%_100%] bg-clip-text text-xl font-semibold text-transparent">
                {t("pages.ai_parser.upload_drag_overlay.uploading_title")}
              </p>
              <p className="text-muted-foreground text-sm">
                {t("pages.ai_parser.upload_drag_overlay.uploading_description")}
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="relative">
              <div className="bg-primary/10 mb-4 flex h-20 w-20 items-center justify-center rounded-full">
                <CloudUpload className="text-primary h-10 w-10" />
              </div>
            </div>
            <div className="text-center">
              <p className="text-foreground mb-2 text-xl font-semibold">
                {t("pages.ai_parser.upload_drag_overlay.drop_title")}
              </p>
              <p className="text-muted-foreground text-sm">
                {t("pages.ai_parser.upload_drag_overlay.drop_description")}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
